import React from 'react'
import { getMomentDate, getDateWithOffset } from '../../utils/date'
import { SingleDatePicker } from '../form'

/**
 * Component to render scheduling date fields (start date and end date)
 * @param {Object} props
 * @param {number} props.index - Index in the schedulingConditions array
 * @param {number} props.sessionIndex - Session number (1-based)
 * @param {Object} props.values - Formik values
 * @param {Object} props.errors - Formik errors
 * @param {Object} props.touched - Formik touched
 * @param {boolean} props.isSowStatusDraft - Whether SOW is in draft status
 * @param {boolean} props.coachingPlanWIP - Whether coaching plan is work in progress
 * @param {boolean} props.viewOnlyField - Whether fields should be view-only
 * @param {Object} props.user - Current user object
 * @param {boolean} props.showModal - Whether modal is showing
 * @param {Object} props.labelProps - Props for label styling
 */
const SchedulingDateFields = ({
  index,
  sessionIndex,
  values,
  errors,
  touched,
  isSowStatusDraft,
  coachingPlanWIP,
  viewOnlyField,
  user,
  showModal,
  labelProps,
}) => {
  const condition = values.schedulingConditions?.[index]?.condition || ''
  const primaryDateFieldName = `schedulingConditions[${index}].primaryDate`
  const secondaryDateFieldName = `schedulingConditions[${index}].secondaryDate`

  const isDisabled =
    isSowStatusDraft || coachingPlanWIP
      ? viewOnlyField && !user?.isAdmin
      : viewOnlyField || showModal

  return (
    <>
      {/* Start Date - Always shown */}
      <SingleDatePicker
        label='START DATE'
        labelProps={labelProps}
        name={primaryDateFieldName}
        sm='10'
        className='pointer-cursor paid-session-input'
        disabled={isDisabled}
        minimumDate={getDateWithOffset(1, 'years', true)}
        position='up'
        maximumDate={getDateWithOffset(1, 'years')}
      />

      {/* End Date - Only shown when condition is 'between' */}
      {condition === 'between' && (
        <SingleDatePicker
          key={`end-date-${sessionIndex}-${
            values.schedulingConditions?.[index]?.primaryDate || ''
          }`}
          label='END DATE'
          labelProps={labelProps}
          name={secondaryDateFieldName}
          sm='10'
          className='pointer-cursor paid-session-input mt-3'
          disabled={isDisabled}
          minimumDate={
            values.schedulingConditions?.[index]?.primaryDate
              ? getMomentDate(
                  values.schedulingConditions[index].primaryDate,
                  'MM/DD/YYYY',
                )
              : getDateWithOffset(1, 'years', true)
          }
          position='up'
          maximumDate={getDateWithOffset(1, 'years')}
        />
      )}
    </>
  )
}

export default SchedulingDateFields
